import { FormattedMessage } from 'react-intl'

import { Delete, HourglassEmpty, Today } from '@mui/icons-material'
import { List, ListItem, ListItemIcon, Stack, Typography } from '@mui/material'

import { useTexts } from '../../useTexts'

export function OperationalStorageTips() {
  const texts = useTexts()
  return (
    <Stack width={444} direction="column" spacing={3}>
      <Stack direction="column" spacing={2}>
        <Typography variant="body1">{texts.storageTipsDescription}</Typography>

        <List
          sx={{
            gap: 2,
            padding: 0,
            '& > li': {
              mb: 2,
              gap: 2,
              padding: 0,
            },
          }}
        >
          <ListItem alignItems="flex-start">
            <ListItemIcon sx={{ minWidth: 'auto', margin: 0 }}>
              <Delete />
            </ListItemIcon>
            <Typography variant="body1">
              <FormattedMessage
                id="option1"
                defaultMessage={texts.option1}
                values={{
                  b: chunks => (
                    <Typography component="span" variant="body1" display="inline" fontWeight="bold">
                      {chunks}
                    </Typography>
                  ),
                }}
              />
            </Typography>
          </ListItem>

          <ListItem alignItems="flex-start">
            <ListItemIcon sx={{ minWidth: 'auto', margin: 0 }}>
              <Today />
            </ListItemIcon>
            <Typography variant="body1">
              <FormattedMessage
                id="option2"
                defaultMessage={texts.option2}
                values={{
                  b: chunks => (
                    <Typography component="span" variant="body1" display="inline" fontWeight="bold">
                      {chunks}
                    </Typography>
                  ),
                }}
              />
            </Typography>
          </ListItem>

          <ListItem alignItems="flex-start">
            <ListItemIcon sx={{ minWidth: 'auto', margin: 0 }}>
              <HourglassEmpty />
            </ListItemIcon>
            <Typography variant="body1">
              <FormattedMessage
                id="option3"
                defaultMessage={texts.option3}
                values={{
                  b: chunks => (
                    <Typography component="span" variant="body1" display="inline" fontWeight="bold">
                      {chunks}
                    </Typography>
                  ),
                }}
              />
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </Stack>
  )
}
